import uniqid from "uniqid";
import { API_HOST } from "../../api_utils/index";

const TwoDCharts = (editor, options) => {
	console.log('options', options);

	const Chart = require("chart.js");

	editor.Blocks.add("barChart", {
	    label: "Bar Chart",
	    category: "Charts",
	    select: true,
	    media:'<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/></svg>',
	    // content: `<canvas id="barChart" width="100" height="100" data-gjs-type="barChart"></canvas>`,
	    content: {type: "bar-chart-container"},
	    draggable: "target, target *",
	});

	editor.Blocks.add("lineChart", {
	    label: "Line Chart",
	    category: "Charts",
	    select: true,
	    media:'<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z"/></svg>',
	    // content: `<canvas id="lineChart" width="100" height="100" data-gjs-type="barChart"></canvas>`,
	    content: {type: "line-chart-container"},
	    draggable: "target, target *",
	});

	editor.Blocks.add("polarAreaChart", {
	    label: "Polar Area Chart",
	    category: "Charts",
	    select: true,
	    media:'<svg viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" width="40" height="40" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><path d="M240,1.77635684e-14 L240.002295,21.3987545 C294.400044,22.7340945 343.747025,44.4318136 380.710057,79.1587315 L396.829822,63.0389608 L404.372294,70.5814332 L388.300091,86.6532201 C422.965999,122.627017 445.115338,170.745603 447.737913,223.998783 L469.333333,224 L469.333333,245.333333 L447.737961,245.333585 C445.163185,297.620932 423.763524,344.958298 390.174602,380.710057 L404.372294,394.907743 L396.829822,402.450216 L382.679118,388.301051 C345.508514,424.119791 295.371823,446.575384 240.002295,447.934579 L240,469.333333 L229.333333,469.333333 L229.332039,447.934603 C173.96162,446.575642 123.824148,424.119606 86.6532201,388.300091 L72.5035115,402.450216 L64.9610392,394.907743 L79.1587315,380.710057 C44.4318136,343.747025 22.7340945,294.400044 21.3987545,240.002295 L1.77635684e-14,240 L1.77635684e-14,229.333333 L21.39873,229.332039 C22.7576912,173.96162 45.2137274,123.824148 81.0332419,86.6532201 L64.9610392,70.5814332 L72.5035115,63.0389608 L88.623319,79.1586912 C125.586573,44.431584 174.933915,22.733828 229.332039,21.39873 L229.333333,1.77635684e-14 L240,1.77635684e-14 Z M162.104101,312.849465 L116.829842,358.123916 C146.267905,386.229951 185.743019,403.913349 229.332642,405.251563 L229.333691,341.202338 C203.413036,339.926048 179.925301,329.397219 162.104101,312.849465 Z M240.000608,341.20229 L240.000798,405.25156 C283.59014,403.913327 323.065021,386.230122 352.503008,358.124377 L307.228806,312.849861 C289.407879,329.397181 265.920674,339.925797 240.000608,341.20229 Z M128.131043,240.000608 L64.0817733,240.000798 C65.390213,282.619707 82.3239474,321.305316 109.347358,350.522008 L154.657229,305.21129 C139.163637,287.652459 129.359926,264.953916 128.131043,240.000608 Z M405.005366,245.33419 L340.806639,245.333581 C338.537929,268.183283 329.058521,288.911749 314.676104,305.21129 L359.986901,350.521007 C385.878073,322.528003 402.507124,285.842835 405.005366,245.33419 Z M229.333,245.62 L177.20211,297.751534 C191.139125,310.45419 209.301217,318.600719 229.333305,319.836041 L229.333,245.62 Z M240,245.621 L240.000828,319.835992 C260.032584,318.600503 278.194365,310.454034 292.131189,297.751564 L240,245.621 Z M219.868,240 L149.497342,240.000828 C150.673352,259.068231 158.110954,276.44137 169.779171,290.08927 L219.868,240 Z M319.339721,245.333968 L254.798,245.333 L299.554162,290.08927 C310.124999,277.724936 317.223568,262.303119 319.339721,245.333968 Z M64.08177,229.332642 L128.130996,229.333691 C129.407285,203.413036 139.936115,179.925301 156.483868,162.104101 L111.209418,116.829842 C83.103382,146.267905 65.4199847,185.743019 64.08177,229.332642 Z M149.497292,229.333305 L223.713,229.333 L171.5818,177.20211 C158.879144,191.139125 150.732614,209.301217 149.497292,229.333305 Z M358.123916,116.829842 L312.849465,162.104101 C328.254307,178.694436 338.442936,200.19559 340.80654,223.99875 L405.005317,223.998344 C402.447484,182.526587 385.078919,145.062321 358.123916,116.829842 Z M297.751534,177.20211 L250.954,223.999 L319.339638,223.9987 C317.105237,206.082471 309.316739,189.891145 297.751534,177.20211 Z M179.243952,169.779267 L229.333,219.868 L229.333305,149.497292 C210.265537,150.673148 192.892059,158.110832 179.243952,169.779267 Z M240.000828,149.497342 L240,219.867 L290.08927,169.779171 C276.44137,158.110954 259.068231,150.673352 240.000828,149.497342 Z M118.811771,109.346945 L164.121956,154.657307 C181.681025,139.16347 204.379962,129.359675 229.333691,128.130996 L229.332642,64.08177 C186.713908,65.3901782 148.028435,82.3237525 118.811771,109.346945 Z M240.000798,64.0817733 L240.000608,128.131043 C264.953916,129.359926 287.652459,139.163637 305.21129,154.657229 L350.521007,109.346432 C321.304433,82.3235606 282.61922,65.3901981 240.000798,64.0817733 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>',
	    // content: `<canvas id="polarAreaChart" width="100" height="100" data-gjs-type="barChart"></canvas>`,
	    content: {type: "polarAreaChart-chart-container"},
	    draggable: "target, target *",
	});

	editor.Blocks.add("bubbleChart", {
	    label: "Bubble Chart",
	    category: "Charts",
	    select: true,
	    media:'<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16a4 4 0 0 0 4-4 4 4 0 0 0 0-8 4 4 0 0 0-8 0 4 4 0 1 0 0 8 4 4 0 0 0 4 4m3-12c0 .073-.01.155-.03.247-.544.241-1.091.638-1.598 1.084A2.987 2.987 0 0 0 8 5c-.494 0-.96.12-1.372.331-.507-.446-1.054-.843-1.597-1.084A1.117 1.117 0 0 1 5 4a3 3 0 0 1 6 0m-.812 6.052A2.99 2.99 0 0 0 11 8a2.99 2.99 0 0 0-.812-2.052c.215-.18.432-.346.647-.487C11.34 5.131 11.732 5 12 5a3 3 0 1 1 0 6c-.268 0-.66-.13-1.165-.461a6.833 6.833 0 0 1-.647-.487m-3.56.617a3.001 3.001 0 0 0 2.744 0c.507.446 1.054.842 1.598 1.084.02.091.03.174.03.247a3 3 0 1 1-6 0c0-.073.01-.155.03-.247.544-.242 1.091-.638 1.598-1.084m-.816-4.721A2.99 2.99 0 0 0 5 8c0 .794.308 1.516.812 2.052a6.83 6.83 0 0 1-.647.487C4.66 10.869 4.268 11 4 11a3 3 0 0 1 0-6c.268 0 .66.13 1.165.461.215.141.432.306.647.487M8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/></svg>',
	    // content: `<canvas id="bubbleChart" width="100" height="100" data-gjs-type="barChart"></canvas>`,
	    content: {type: "bubble-chart-container"},
	    draggable: "target, target *",
	});

	editor.Blocks.add("doughnutChart", {
	    label: "Doughnut Chart",
	    category: "Charts",
	    select: true,
	    media:'<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#000000"> <path fill="none" d="M0 0H24V24H0z"></path> <path d="M11 2.05v2.012C7.054 4.554 4 7.92 4 12c0 4.418 3.582 8 8 8 1.849 0 3.55-.627 4.906-1.68l1.423 1.423C16.605 21.153 14.4 22 12 22 6.477 22 2 17.523 2 12c0-5.185 3.947-9.449 9-9.95zM21.95 13c-.2 2.011-.994 3.847-2.207 5.328l-1.423-1.422c.86-1.107 1.436-2.445 1.618-3.906h2.013zM13.002 2.05c4.724.469 8.48 4.226 8.95 8.95h-2.013c-.451-3.618-3.319-6.486-6.937-6.938V2.049z"></path></svg>',
	    // content: `<canvas id="doughnutChart" width="100" height="100" data-gjs-type="barChart"></canvas>`,
	    content: {type: "doughnut-chart-container"},
	    draggable: "target, target *",
	});

	editor.Blocks.add("pieChart", {
	    label: "Pie Chart",
	    category: "Charts",
	    select: true,
	    media:'<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16"><path d="M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z"/></svg>',
	    // content: `<canvas id="pieChart" width="100" height="100" data-gjs-type="barChart"></canvas>`,
	    content: {type: "pie-chart-container"},
	    draggable: "target, target *",
	});

	if (editor !== null && editor !== undefined) {
	    const defaultType = editor.DomComponents.getType("default");
	    const defaultModel = defaultType.model;
	    const defaultView = defaultType.view;
    
    	// 2D BAR CHART
	    editor.DomComponents.addType('bar-chart-container', {
	        model: {
	          defaults: {
	            tagName: 'div',
	            type: "bar-chart-container",
	            attributes: {
	              class: "bar-chart-container",
	              style: 'padding: 0.5em',
	            },

	            components: [
		            {
						type: "bar-chart-uf",
					}, {
		                type: "bar-chart",
		            },
	            ],

	            traits: ["id"],
	          },
	        },
	    });

	    editor.DomComponents.addType("bar-chart-uf", {
	    	model: {
	    		defaults: {
	    			tagName: "span",
	    			type: "bar-chart-uf",
	    			attributes: {
	    				id: "bar-chart-uf",
	    				class: "bar-chart-uf",
	    				style: "width: max-content;",
	    			},

	    			components: [
	    				{
	    					tagName: "select",
	    					type: "bar-chart-uf-opts",
	    					attributes: {
			    				id: "bar-chart-uf-opts",
			    				name: "bar-chart-uf-opts",
			    				class: "bar-chart-uf-opts",
			    			},

			    			components: [
			    				{
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "",
			    						disabled: "true",
			    						selected: "true",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "-uf-",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "5000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "10000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "20000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "20s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "30000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "30s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "60000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "60s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "120000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "2min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "300000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "600000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "Stop",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "Stop",
								            },
								        },
									],
			    				},
			    			],

			    			// traits
			    			traits: ["id"],
			    			changeProp: true,
	    				},
	    			],

	    			traits: [
	    				"id",
	    			],
			    	changeProp: true,
	    		},
	    	},
	    });

	    editor.DomComponents.addType("bar-chart", {
	        model: {
	          defaults: {
	            tagName: "div",
	            type: "bar-chart",
	            attributes: {
	              // id: "3d-chart",
	              class: "bar-chart",
	              // style: "width: 500px; height: 500px;",
	              'data-gjs-type': "bar-chart",
	            },

	            components: [
	              {
	                tagName: "canvas",
	                type: "bar-chart-canvas",
	                attributes: {
	                  // id: "3d-chart",
	                  class: "bar-chart-canvas",
	                  // style: "width: 500px; height: 500px;",
	                  'data-gjs-type': "bar-chart-canvas",
	                },

	                "style-default": {
	                  width: '500px',
	                  height: '500px',
	                },

	                style: {
	                  width: '500px',
	                  height: '500px',
	                },
	              },
	            ],

	            script: function (props) {
	              console.log('this', this, props);
	              let container = this;
	              let idEl = this.id;
					const url = window.top.location.href;
					const isSubstringPresent = (url.indexOf("/editor/") !== -1 && url.indexOf("?projectId=") !== -1) || url.indexOf("/large_preview/") !== -1 || url.indexOf("/tab_preview/") !== -1 || url.indexOf("/mobile_preview/") !== -1 || url.indexOf("/fragment_editor/") !== -1;

	              const initLib = async function () {
	              	console.log('props.BaseVars', props.BaseVars);

	              	// base url bearer token taken directly from local storage after getting downloaded
					let baseUrlData, dynamicBaseUrlBearerToken, baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken;
					// getting baseUrl data from local storage for run-time access
					let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
					if (baseUrlDataFromStorage) {
						baseUrlData = JSON.parse(baseUrlDataFromStorage);
					}
					// extracting token values from base URLs from baseUrlData
					if (baseUrlData) {
						try {
							if (`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl1BearerToken = baseUrlData[`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl2BearerToken = baseUrlData[`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl3BearerToken = baseUrlData[`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl4BearerToken = baseUrlData[`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl5BearerToken = baseUrlData[`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
						} catch (e) {
							// statements
							console.log(e);
						}
					}

	              	// helper function to get value of a key in nested object
					function findKeyValue(obj, key) {
					    if (obj.hasOwnProperty(key)) {
					        // If the current object has the key, return its value
					        return obj[key];
					    }

					    for (var prop in obj) {
					        if (obj.hasOwnProperty(prop) && typeof obj[prop] === 'object') {
					            // If the current property is an object, recursively search within it
					            var result = findKeyValue(obj[prop], key);
					            if (result !== undefined) {
					                return result;
					            }
					        }
					    }
					    // Key not found in the object
					    return undefined;
					}
	              	
	                // this helper function recursively scans an object and its nests until it finds the key and returns its value
	                function findKeyInNestedObject(response, key) {
	                  let values = [];

	                  function traverseObject(obj) {
	                    for (let prop in obj) {
	                      if (typeof obj[prop] === "object") {
	                        traverseObject(obj[prop]);
	                      } else if (Array.isArray(obj[prop])) {
	                        for (let item of obj[prop]) {
	                          if (typeof item === "object") {
	                            traverseObject(item);
	                          }
	                        }
	                      } else if (prop === key) {
	                        values.push(Number(obj[prop]));
	                      }
	                    }
	                  }

	                  traverseObject(response);

	                  return values;
	                }

	                // this helper function checks if an object has multiple levels of nesting
	                function isNestedObject(response) {
	                  if (typeof response !== "object") {
	                    return false; // Not an object
	                  }

	                  for (let prop in response) {
	                    if (typeof response[prop] === "object") {
	                      return true; // Found nested object
	                    }
	                  }

	                  return false; // No nested object found
	                }

	                // this helper function checks if there is an array of objects in a response object
	                function hasArrayofObjects(obj) {
	                  for (let prop in obj) {
	                    if (
	                      Array.isArray(obj[prop]) &&
	                      obj[prop].length > 0 &&
	                      typeof obj[prop][0] === "object"
	                    ) {
	                      return true; // Array of objects found
	                    }
	                  }
	                  return false; // Array of objects not found
	                }

	                let username = props.Username;
	                let password = props.Password;
	                let apiKey = props.API_key;
	                let moreHeaders = props.More_Headers;
	                let apiMethod = props.APIMethod;
	                let apiBody = props.APIBody;

	                let Graph_API = props.CustomUrl;
	                // to rename a variable because API var is getting used in many places in this block scope
		            let API;
		            if (props.APIPath) {
		              API = props.APIPath;
		            }

	                let xAxis = [];
	                let yAxis = [];

	                console.log("Graph props:", props);

	                // GET method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bar",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bar-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (Chart) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                  			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			            let url, baseUrlBearerToken;
						let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}

			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bar",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bar-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	                // POST method
	                else if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {	                        	
	                        	"Content-Type": "application/json",								
	                          	Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
							},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config@:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bar",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bar-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (Chart) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
						let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}

			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bar",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bar-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bar-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bar-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                  			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	              };

	                // to update chart props as soon as window props is updated and then trigger rendering so that the chart updates
					if (!isSubstringPresent) {
				        setInterval(function () {
				          Object.keys(props).forEach(function (key) {
				            if (window[`${key}${idEl}`]) {
				              if(props[key]===window[`${key}${idEl}`]){
				                // console.log('');
				              }else{
				                props[key] = window[`${key}${idEl}`];
				               	initLib();
				              }
				            }
				          });
				        }, 500);
				    }

	              if (typeof Chart == "undefined") {
	                const script = document.createElement("script");
	                script.onload = initLib;
	                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
	                document.body.appendChild(script);
	              } else {
	                console.log("InitLib");
	                initLib();

	                let updateFrequencyValue, updateFrequencyRef;
            		let updateFrequency = (props.UpdateFrequencyDropdownID) ? document.getElementById(`${props.UpdateFrequencyDropdownID}`) : document.getElementById('bar-chart-uf-opts');
            		
            		if (updateFrequency) {
	            		updateFrequency.addEventListener('change', (event) => {
	            			console.log('updateFrequency value:', updateFrequency.value);
	            			updateFrequencyValue = updateFrequency.value;

	            			// Clear the previous interval if it exists
						    if (updateFrequencyRef) {
						        clearInterval(updateFrequencyRef);
						    }

						    if (updateFrequencyValue !== 'Stop') {
						        // Set a new interval
						        updateFrequencyRef = setInterval(initLib, parseInt(updateFrequencyValue)); // Ensure updateFrequencyValue is a number
						    } else {
						        console.log('STOPPED & running one last time');
						        initLib();
						    }

						    console.log('updateFrequencyValue, updateFrequencyRef', updateFrequencyValue, updateFrequencyRef);
	            		});
            		}            		
	              }
	            },

	            CustomUrl: "",
	            BaseUrl: "",
	            APIPath: "",
	            APIMethod: "GET",
	            Username: "",
	            Password: "",
	            API_Key: "",
	            More_Headers: "", // input should be like: a:b,c:d,e:f
	            APIBody: "",
	            BaseVars: options,
	            API_HOST: API_HOST,
				projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
				options: options,

	            Animation: "",
	            Abscissa: "",
	            Ordinate: "",
	            Bar_Colors: "",
	            Border_Width: "",
	            Border_Color: "",
	            UpdateFrequencyDropdownID: "bar-chart-uf-opts",
	            // Fill: "",
				DisableLegend: false,

	            traits: [
	              {
	                type: "text",
	                name: "CustomUrl",
	                label: "Custom URL",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "BaseUrl",
	                label: "Base URL",
	                options: [
	                  { id: "baseUrl1", name: "Base URL #1" },
	                  { id: "baseUrl2", name: "Base URL #2" },
	                  { id: "baseUrl3", name: "Base URL #3" },
	                  { id: "baseUrl4", name: "Base URL #4" },
	                  { id: "baseUrl5", name: "Base URL #5" },
	                  { id: "null", name: "No Base URL" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIPath",
	                label: "API Path",
	                placeholder: "Don't start with '/'",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "APIMethod",
	                label: "API Method",
	                options: [
	                  { id: "GET", name: "GET" },
	                  { id: "POST", name: "POST" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Username",
	                label: "Username",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Password",
	                label: "Password",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "API_Key",
	                label: "API Key",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "More_Headers",
	                label: "More Headers",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIBody",
	                label: "API Body",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "Animation",
	                label: "Pre-defined Graph Animations",
	                options: [
	                  { id: "delay", name: "Delay" },
	                  { id: "hideAndShow", name: "Hide And Show" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Abscissa",
	                label: "Abscissa",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Ordinate",
	                label: "Ordinates",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Bar_Colors",
	                label: "Datapoint Colors",
	                changeProp: true,
	              },
	              {
	                type: "range",
	                min: "0",
	                max: "20",
	                name: "Border_Width",
	                label: "Border Width [0px to 20px]",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Border_Color",
	                label: "Border Color",
	                changeProp: true,
	              },
		            {
		                type: "text",
		                name: "UpdateFrequencyDropdownID",
		                label: "UpdateFrequency Dropdown ID",
		                placeholder: "For example: bar-chart-uf-opts",
		                changeProp: true,
		            },
	              // {
	              //     type: 'checkbox',
	              //     name: 'Fill',
	              //     label: 'Fill Area',
	              //     changeProp: true,
	              // },
				  {
	                  type: 'checkbox',
	                  name: 'DisableLegend',
	                  label: 'Disable Legend',
	                  changeProp: true,
	              },
	            ],

	            changeProp: true,

	            "script-props": [
	              "CustomUrl",
	              "BaseUrl",
	              "APIPath",
	              "APIMethod",
	              "BaseVars",
	              "API_HOST",
	              "projectId",
	              "Username",
	              "Password",
	              "API_Key",
	              "More_Headers",	             
	              "APIBody",	             
	              "Animation",
	              "Abscissa",
	              "Ordinate",
	              "Bar_Colors",
	              "Border_Width",
	              "Border_Color",
	              "UpdateFrequencyDropdownID",
				  "options",
				  "DisableLegend",
	            ],
	          },
	        },

	        isComponent: (el) => {
	          if (
	            el.getAttribute &&
	            el.getAttribute("data-gjs-type") == "bar-chart"
	          ) {
	            return "bar-chart";
	          }
	        },
	        view: defaultView.extend({
	          init({ model }) {},
	        }),
	    });
    
    	// 2D LINE CHART
	    editor.DomComponents.addType('line-chart-container', {
	        model: {
	          defaults: {
	            tagName: 'div',
	            type: "line-chart-container",
	            attributes: {
	              class: "line-chart-container",
	              style: 'padding: 0.5em',
	            },

	            components: [
		            {
						type: "line-chart-uf",
					}, {
		                type: "line-chart",
		            },
	            ],

	            traits: ["id"],
	          },
	        },
	    });

	    editor.DomComponents.addType("line-chart-uf", {
	    	model: {
	    		defaults: {
	    			tagName: "span",
	    			type: "line-chart-uf",
	    			attributes: {
	    				id: "line-chart-uf",
	    				class: "line-chart-uf",
	    				style: "width: max-content;",
	    			},

	    			components: [
	    				{
	    					tagName: "select",
	    					type: "line-chart-uf-opts",
	    					attributes: {
			    				id: "line-chart-uf-opts",
			    				name: "line-chart-uf-opts",
			    				class: "line-chart-uf-opts",
			    			},

			    			components: [
			    				{
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "",
			    						disabled: "true",
			    						selected: "true",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "-uf-",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "5000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "10000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "20000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "20s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "30000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "30s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "60000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "60s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "120000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "2min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "300000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "600000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					type: "uf-option",
			    					attributes: {
			    						value: "Stop",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "Stop",
								            },
								        },
									],
			    				},
			    			],

			    			// traits
			    			traits: ["id"],
			    			changeProp: true,
	    				},
	    			],

	    			traits: [
	    				"id",
	    			],
			    	changeProp: true,
	    		},
	    	},
	    });

	    editor.DomComponents.addType("line-chart", {
	        model: {
	          defaults: {
	            tagName: "div",
			    type: "line-chart",
	            attributes: {
	              // id: "3d-chart",
	              class: "line-chart",
	              // style: "width: 500px; height: 500px;",
	              'data-gjs-type': "line-chart",
	            },

	            components: [
	              {
	                tagName: "canvas",
	                type: "line-chart-canvas",
	                attributes: {
	                  // id: "3d-chart",
	                  class: "line-chart-canvas",
	                  // style: "width: 500px; height: 500px;",
	                  'data-gjs-type': "line-chart-canvas",
	                },

	                "style-default": {
	                  width: '500px',
	                  height: '500px',
	                },

	                style: {
	                  width: '500px',
	                  height: '500px',
	                },
	              },
	            ],

	            script: function (props) {
	              console.log('this', this);
	              let container = this;
	              let idEl = this.id;
					const url = window.top.location.href;
					const isSubstringPresent = (url.indexOf("/editor/") !== -1 && url.indexOf("?projectId=") !== -1) || url.indexOf("/large_preview/") !== -1 || url.indexOf("/tab_preview/") !== -1 || url.indexOf("/mobile_preview/") !== -1 || url.indexOf("/fragment_editor/") !== -1;

	              const initLib = async function () {
	              	console.log('props.BaseVars', props.BaseVars);

	              	// base url bearer token taken directly from local storage after getting downloaded
					let baseUrlData, dynamicBaseUrlBearerToken, baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken;
					// getting baseUrl data from local storage for run-time access
					let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
					if (baseUrlDataFromStorage) {
						baseUrlData = JSON.parse(baseUrlDataFromStorage);
					}
					// extracting token values from base URLs from baseUrlData
					if (baseUrlData) {
						try {
							if (`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl1BearerToken = baseUrlData[`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl2BearerToken = baseUrlData[`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl3BearerToken = baseUrlData[`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl4BearerToken = baseUrlData[`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl5BearerToken = baseUrlData[`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
						} catch (e) {
							// statements
							console.log(e);
						}
					}

	              	// helper function to get value of a key in nested object
					function findKeyValue(obj, key) {
					    if (obj.hasOwnProperty(key)) {
					        // If the current object has the key, return its value
					        return obj[key];
					    }

					    for (var prop in obj) {
					        if (obj.hasOwnProperty(prop) && typeof obj[prop] === 'object') {
					            // If the current property is an object, recursively search within it
					            var result = findKeyValue(obj[prop], key);
					            if (result !== undefined) {
					                return result;
					            }
					        }
					    }
					    // Key not found in the object
					    return undefined;
					}

	                // this helper function recursively scans an object and its nests until it finds the key and returns its value
	                function findKeyInNestedObject(response, key) {
	                  let values = [];

	                  function traverseObject(obj) {
	                    for (let prop in obj) {
	                      if (typeof obj[prop] === "object") {
	                        traverseObject(obj[prop]);
	                      } else if (Array.isArray(obj[prop])) {
	                        for (let item of obj[prop]) {
	                          if (typeof item === "object") {
	                            traverseObject(item);
	                          }
	                        }
	                      } else if (prop === key) {
	                        values.push(Number(obj[prop]));
	                      }
	                    }
	                  }

	                  traverseObject(response);

	                  return values;
	                }

	                // this helper function checks if an object has multiple levels of nesting
	                function isNestedObject(response) {
	                  if (typeof response !== "object") {
	                    return false; // Not an object
	                  }

	                  for (let prop in response) {
	                    if (typeof response[prop] === "object") {
	                      return true; // Found nested object
	                    }
	                  }

	                  return false; // No nested object found
	                }

	                // this helper function checks if there is an array of objects in a response object
	                function hasArrayofObjects(obj) {
	                  for (let prop in obj) {
	                    if (
	                      Array.isArray(obj[prop]) &&
	                      obj[prop].length > 0 &&
	                      typeof obj[prop][0] === "object"
	                    ) {
	                      return true; // Array of objects found
	                    }
	                  }
	                  return false; // Array of objects not found
	                }

	                let username = props.Username;
	                let password = props.Password;
	                let apiKey = props.API_key;
	                let moreHeaders = props.More_Headers;
	                let apiMethod = props.APIMethod;
	                let apiBody = props.APIBody;

	                let Graph_API = props.CustomUrl;
	                // to rename a variable because API var is getting used in many places in this block scope
		            let API;
		            if (props.APIPath) {
		              API = props.APIPath;
		            }

	                let xAxis = [];
	                let yAxis = [];

	                console.log("Graph props:", props, "\n\nusername:", username, "\npassword:", password, "\napiKey:", apiKey, "\nmoreHeaders:", moreHeaders );

	                // GET method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(`${Graph_API}`, config );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                      	// just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                         console.log('#');
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   console.log('##');
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "line",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('line-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                   			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "line",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('line-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                   			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	                // POST method
	                else if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {	                        	
	                        	"Content-Type": "application/json",								
	                          	Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
							},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config@:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "line",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('line-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
						let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "line",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('line-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('line-chart-canvas')[0].width, container.getElementsByClassName('line-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('line-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                   			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }
	              };

	              // to update chart props as soon as window props is updated and then trigger rendering so that the chart updates
					if (!isSubstringPresent) {
				        setInterval(function () {
				          Object.keys(props).forEach(function (key) {
				            if (window[`${key}${idEl}`]) {
				              if(props[key]===window[`${key}${idEl}`]){
				                // console.log('');
				              }else{
				                props[key] = window[`${key}${idEl}`];
				               	initLib();
				              }
				            }
				          });
				        }, 500);
				    }

	              if (typeof Chart == "undefined") {
	                const script = document.createElement("script");
	                script.onload = initLib;
	                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
	                document.body.appendChild(script);
	              } else {
	                console.log("InitLib");
	                initLib();

	                let updateFrequencyValue, updateFrequencyRef;
            		let updateFrequency = (props.UpdateFrequencyDropdownID) ? document.getElementById(`${props.UpdateFrequencyDropdownID}`) : document.getElementById('line-chart-uf-opts');
            			
            		if (updateFrequency) {
	            		updateFrequency.addEventListener('change', (event) => {
	            			console.log('updateFrequency value:', updateFrequency.value);
	            			updateFrequencyValue = updateFrequency.value;

	            			// Clear the previous interval if it exists
						    if (updateFrequencyRef) {
						        clearInterval(updateFrequencyRef);
						    }

						    if (updateFrequencyValue !== 'Stop') {
						        // Set a new interval
						        updateFrequencyRef = setInterval(initLib, parseInt(updateFrequencyValue)); // Ensure updateFrequencyValue is a number
						    } else {
						        console.log('STOPPED & running one last time');
						        initLib();
						    }

						    console.log('updateFrequencyValue, updateFrequencyRef', updateFrequencyValue, updateFrequencyRef);
	            		});
            		}            		
	              }
	            },

	            CustomUrl: "",
	            BaseUrl: "",
	            APIPath: "",
	            APIMethod: "GET",
	            Username: "",
	            Password: "",
	            API_Key: "",
	            More_Headers: "", // input should be like: a:b,c:d,e:f
	            APIBody: "",
	            BaseVars: options,
	            API_HOST: API_HOST,
				projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
				options: options,

	            Animation: "",
	            Abscissa: "",
	            Ordinate: "",
	            Bar_Colors: "",
	            Border_Width: "",
	            Border_Color: "",
	            UpdateFrequencyDropdownID: "line-chart-uf-opts",
	            // Fill: "",
				DisableLegend: false,

	            traits: [
	              {
	                type: "text",
	                name: "CustomUrl",
	                label: "Custom URL",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "BaseUrl",
	                label: "Base URL",
	                options: [
	                  { id: "baseUrl1", name: "Base URL #1" },
	                  { id: "baseUrl2", name: "Base URL #2" },
	                  { id: "baseUrl3", name: "Base URL #3" },
	                  { id: "baseUrl4", name: "Base URL #4" },
	                  { id: "baseUrl5", name: "Base URL #5" },
	                  { id: "null", name: "No Base URL" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIPath",
	                label: "API Path",
	                placeholder: "Don't start with '/'",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "APIMethod",
	                label: "API Method",
	                options: [
	                  { id: "GET", name: "GET" },
	                  { id: "POST", name: "POST" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Username",
	                label: "Username",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Password",
	                label: "Password",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "API_Key",
	                label: "API Key",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "More_Headers",
	                label: "More Headers",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIBody",
	                label: "API Body",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "Animation",
	                label: "Pre-defined Graph Animations",
	                options: [
	                  { id: "delay", name: "Delay" },
	                  { id: "hideAndShow", name: "Hide And Show" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Abscissa",
	                label: "Abscissa",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Ordinate",
	                label: "Ordinates",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Bar_Colors",
	                label: "Datapoint Colors",
	                changeProp: true,
	              },
	              {
	                type: "range",
	                min: "0",
	                max: "20",
	                name: "Border_Width",
	                label: "Border Width [0px to 20px]",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Border_Color",
	                label: "Border Color",
	                changeProp: true,
	              },
		            {
		                type: "text",
		                name: "UpdateFrequencyDropdownID",
		                label: "UpdateFrequency Dropdown ID",
		                placeholder: "For example: line-chart-uf-opts",
		                changeProp: true,
		            },
	              // {
	              //     type: 'checkbox',
	              //     name: 'Fill',
	              //     label: 'Fill Area',
	              //     changeProp: true,
	              // },
				  {
	                  type: 'checkbox',
	                  name: 'DisableLegend',
	                  label: 'Disable Legend',
	                  changeProp: true,
	              },
	            ],

	            changeProp: true,

	            "script-props": [
	              "CustomUrl",
	              "BaseUrl",
	              "APIPath",
	              "APIMethod",
	              "BaseVars",
	              "API_HOST",
	              "projectId",
	              "Username",
	              "Password",
	              "API_Key",
	              "More_Headers",	             
	              "APIBody",
	              "BaseVars",
	              "Animation",
	              "Abscissa",
	              "Ordinate",
	              "Bar_Colors",
	              "Border_Width",
	              "Border_Color",
	              "UpdateFrequencyDropdownID",
				  "options",
				  "DisableLegend",
	            ],
	          },
	        },

	        isComponent: (el) => {
	          if (
	            el.getAttribute &&
	            el.getAttribute("data-gjs-type") == "line-chart"
	          ) {
	            return "line-chart";
	          }
	        },
	        view: defaultView.extend({
	          init({ model }) {},
	        }),
	    });
    
    	// 2D POLAR-AREA CHART
	    editor.DomComponents.addType('polarAreaChart-chart-container', {
	        model: {
	          defaults: {
	            tagName: 'div',
	            attributes: {
	              class: "polarAreaChart-chart-container",
	              style: 'padding: 0.5em',
	            },

	            components: [
		            {
						type: "polarAreaChart-chart-uf",
					}, {
		                type: "polarAreaChart-chart",
		            },
	            ],

	            traits: ["id"],
	          },
	        },
	    });

	    editor.DomComponents.addType("polarAreaChart-chart-uf", {
	    	model: {
	    		defaults: {
	    			tagName: "span",
	    			attributes: {
	    				id: "polarAreaChart-chart-uf",
	    				class: "polarAreaChart-chart-uf",
	    				style: "width: max-content;",
	    			},

	    			components: [
	    				{
	    					tagName: "select",
	    					attributes: {
			    				id: "polarAreaChart-chart-uf-opts",
			    				name: "polarAreaChart-chart-uf-opts",
			    				class: "polarAreaChart-chart-uf-opts",
			    			},

			    			components: [
			    				{
			    					tagName: "option",
			    					attributes: {
			    						value: "",
			    						disabled: "true",
			    						selected: "true",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "-uf-",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "30000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "30s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "60000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "60s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "120000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "2min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "300000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "600000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "Stop",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "Stop",
								            },
								        },
									],
			    				},
			    			],

			    			// traits
			    			traits: ["id"],
			    			changeProp: true,
	    				},
	    			],

	    			traits: [
	    				"id",
	    			],
			    	changeProp: true,
	    		},
	    	},
	    });

	    editor.DomComponents.addType("polarAreaChart-chart", {
	        model: {
	          defaults: {
	            tagName: "div",
	            attributes: {
	              // id: "3d-chart",
	              class: "polarAreaChart-chart",
	              // style: "width: 500px; height: 500px;",
	              'data-gjs-type': "polarAreaChart-chart",
	            },

	            components: [
	              {
	                tagName: "canvas",
	                attributes: {
	                  // id: "3d-chart",
	                  class: "polarAreaChart-chart-canvas",
	                  // style: "width: 500px; height: 500px;",
	                  'data-gjs-type': "polarAreaChart-chart-canvas",
	                },

	                "style-default": {
	                  width: '500px',
	                  height: '500px',
	                },

	                style: {
	                  width: '500px',
	                  height: '500px',
	                },
	              },
	            ],

	            script: function (props) {
	              console.log('this', this);
	              let container = this;
	              let idEl = this.id;
					const url = window.top.location.href;
					const isSubstringPresent = (url.indexOf("/editor/") !== -1 && url.indexOf("?projectId=") !== -1) || url.indexOf("/large_preview/") !== -1 || url.indexOf("/tab_preview/") !== -1 || url.indexOf("/mobile_preview/") !== -1 || url.indexOf("/fragment_editor/") !== -1;


	              const initLib = async function () {
	              	console.log('props.BaseVars', props.BaseVars);

	              	// base url bearer token taken directly from local storage after getting downloaded
					let baseUrlData, dynamicBaseUrlBearerToken, baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken;
					// getting baseUrl data from local storage for run-time access
					let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
					if (baseUrlDataFromStorage) {
						baseUrlData = JSON.parse(baseUrlDataFromStorage);
					}
					// extracting token values from base URLs from baseUrlData
					if (baseUrlData) {
						try {
							if (`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl1BearerToken = baseUrlData[`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl2BearerToken = baseUrlData[`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl3BearerToken = baseUrlData[`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl4BearerToken = baseUrlData[`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl5BearerToken = baseUrlData[`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
						} catch (e) {
							// statements
							console.log(e);
						}
					}

	              	// helper function to get value of a key in nested object
					function findKeyValue(obj, key) {
					    if (obj.hasOwnProperty(key)) {
					        // If the current object has the key, return its value
					        return obj[key];
					    }

					    for (var prop in obj) {
					        if (obj.hasOwnProperty(prop) && typeof obj[prop] === 'object') {
					            // If the current property is an object, recursively search within it
					            var result = findKeyValue(obj[prop], key);
					            if (result !== undefined) {
					                return result;
					            }
					        }
					    }
					    // Key not found in the object
					    return undefined;
					}

	                // this helper function recursively scans an object and its nests until it finds the key and returns its value
	                function findKeyInNestedObject(response, key) {
	                  let values = [];

	                  function traverseObject(obj) {
	                    for (let prop in obj) {
	                      if (typeof obj[prop] === "object") {
	                        traverseObject(obj[prop]);
	                      } else if (Array.isArray(obj[prop])) {
	                        for (let item of obj[prop]) {
	                          if (typeof item === "object") {
	                            traverseObject(item);
	                          }
	                        }
	                      } else if (prop === key) {
	                        values.push(Number(obj[prop]));
	                      }
	                    }
	                  }

	                  traverseObject(response);

	                  return values;
	                }

	                // this helper function checks if an object has multiple levels of nesting
	                function isNestedObject(response) {
	                  if (typeof response !== "object") {
	                    return false; // Not an object
	                  }

	                  for (let prop in response) {
	                    if (typeof response[prop] === "object") {
	                      return true; // Found nested object
	                    }
	                  }

	                  return false; // No nested object found
	                }

	                // this helper function checks if there is an array of objects in a response object
	                function hasArrayofObjects(obj) {
	                  for (let prop in obj) {
	                    if (
	                      Array.isArray(obj[prop]) &&
	                      obj[prop].length > 0 &&
	                      typeof obj[prop][0] === "object"
	                    ) {
	                      return true; // Array of objects found
	                    }
	                  }
	                  return false; // Array of objects not found
	                }

	                let username = props.Username;
	                let password = props.Password;
	                let apiKey = props.API_key;
	                let moreHeaders = props.More_Headers;
	                let apiMethod = props.APIMethod;
	                let apiBody = props.APIBody;

	                let Graph_API = props.CustomUrl;
	                // to rename a variable because API var is getting used in many places in this block scope
		            let API;
		            if (props.APIPath) {
		              API = props.APIPath;
		            }

	                let xAxis = [];
	                let yAxis = [];

	                console.log("Graph props:", props, "\n\nusername:", username, "\npassword:", password, "\napiKey:", apiKey, "\nmoreHeaders:", moreHeaders );

	                // GET method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "polarArea",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('polarAreaChart-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "polarArea",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('polarAreaChart-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	                // POST method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {	                        	
	                        	"Content-Type": "application/json",								
	                          	Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
							},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config@:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "polarArea",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('polarAreaChart-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                  			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "polarArea",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('polarAreaChart-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('bar-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].width, container.getElementsByClassName('polarAreaChart-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('polarAreaChart-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                  			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }
	              };

	              // to update chart props as soon as window props is updated and then trigger rendering so that the chart updates
					if (!isSubstringPresent) {
				        setInterval(function () {
				          Object.keys(props).forEach(function (key) {
				            if (window[`${key}${idEl}`]) {
				              if(props[key]===window[`${key}${idEl}`]){
				                // console.log('');
				              }else{
				                props[key] = window[`${key}${idEl}`];
				               	initLib();
				              }
				            }
				          });
				        }, 500);
				    }

	              if (typeof Chart == "undefined") {
	                const script = document.createElement("script");
	                script.onload = initLib;
	                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
	                document.body.appendChild(script);
	              } else {
	                console.log("InitLib");
	                initLib();

	                let updateFrequencyValue, updateFrequencyRef;
            		let updateFrequency = (props.UpdateFrequencyDropdownID) ? document.getElementById(`${props.UpdateFrequencyDropdownID}`) : document.getElementById('polarAreaChart-chart-uf-opts');
            			
            		if (updateFrequency) {
	            		updateFrequency.addEventListener('change', (event) => {
	            			console.log('updateFrequency value:', updateFrequency.value);
	            			updateFrequencyValue = updateFrequency.value;

	            			// Clear the previous interval if it exists
						    if (updateFrequencyRef) {
						        clearInterval(updateFrequencyRef);
						    }

						    if (updateFrequencyValue !== 'Stop') {
						        // Set a new interval
						        updateFrequencyRef = setInterval(initLib, parseInt(updateFrequencyValue)); // Ensure updateFrequencyValue is a number
						    } else {
						        console.log('STOPPED & running one last time');
						        initLib();
						    }

						    console.log('updateFrequencyValue, updateFrequencyRef', updateFrequencyValue, updateFrequencyRef);
	            		});
            		}
            		
	              }
	            },

	            CustomUrl: "",
	            BaseUrl: "",
	            APIPath: "",
	            APIMethod: "GET",
	            Username: "",
	            Password: "",
	            API_Key: "",
	            More_Headers: "", // input should be like: a:b,c:d,e:f
	            APIBody: "",
	            BaseVars: options,
				projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
				options: options,

	            Animation: "",
	            Abscissa: "",
	            Ordinate: "",
	            Bar_Colors: "",
	            Border_Width: "",
	            Border_Color: "",
	            UpdateFrequencyDropdownID: "polarAreaChart-chart-uf-opts",
	            // Fill: "",
				DisableLegend: false,

	            traits: [
	              {
	                type: "text",
	                name: "CustomUrl",
	                label: "Custom URL",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "BaseUrl",
	                label: "Base URL",
	                options: [
	                  { id: "baseUrl1", name: "Base URL #1" },
	                  { id: "baseUrl2", name: "Base URL #2" },
	                  { id: "baseUrl3", name: "Base URL #3" },
	                  { id: "baseUrl4", name: "Base URL #4" },
	                  { id: "baseUrl5", name: "Base URL #5" },
	                  { id: "null", name: "No Base URL" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIPath",
	                label: "API Path",
	                placeholder: "Don't start with '/'",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "APIMethod",
	                label: "API Method",
	                options: [
	                  { id: "GET", name: "GET" },
	                  { id: "POST", name: "POST" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Username",
	                label: "Username",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Password",
	                label: "Password",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "API_Key",
	                label: "API Key",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "More_Headers",
	                label: "More Headers",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIBody",
	                label: "API Body",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "Animation",
	                label: "Pre-defined Graph Animations",
	                options: [
	                  { id: "delay", name: "Delay" },
	                  { id: "hideAndShow", name: "Hide And Show" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Abscissa",
	                label: "Abscissa",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Ordinate",
	                label: "Ordinates",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Bar_Colors",
	                label: "Datapoint Colors",
	                changeProp: true,
	              },
	              {
	                type: "range",
	                min: "0",
	                max: "20",
	                name: "Border_Width",
	                label: "Border Width [0px to 20px]",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Border_Color",
	                label: "Border Color",
	                changeProp: true,
	              },
		            {
		                type: "text",
		                name: "UpdateFrequencyDropdownID",
		                label: "UpdateFrequency Dropdown ID",
		                placeholder: "For example: polarAreaChart-chart-uf-opts",
		                changeProp: true,
		            },
	              // {
	              //     type: 'checkbox',
	              //     name: 'Fill',
	              //     label: 'Fill Area',
	              //     changeProp: true,
	              // },
				  {
	                  type: 'checkbox',
	                  name: 'DisableLegend',
	                  label: 'Disable Legend',
	                  changeProp: true,
	              },
	            ],

	            changeProp: true,

	            "script-props": [
	              "CustomUrl",
	              "BaseUrl",
	              "APIPath",
	              "APIMethod",
	              "BaseVars",
	              "API_HOST",
	              "projectId",
	              "Username",
	              "Password",
	              "API_Key",
	              "More_Headers",	             
	              "APIBody",
	              "Animation",
	              "Abscissa",
	              "Ordinate",
	              "Bar_Colors",
	              "Border_Width",
	              "Border_Color",
	              "UpdateFrequencyDropdownID",
				  "options",
				  "DisableLegend",
	            ],
	          },
	        },

	        isComponent: (el) => {
	          if (
	            el.getAttribute &&
	            el.getAttribute("data-gjs-type") == "polarAreaChart-chart"
	          ) {
	            return "polarAreaChart-chart";
	          }
	        },
	        view: defaultView.extend({
	          init({ model }) {},
	        }),
	    });
    
    	// 2D BUBBLE CHART
	    editor.DomComponents.addType('bubble-chart-container', {
	        model: {
	          defaults: {
	            tagName: 'div',
	            attributes: {
	              class: "bubble-chart-container",
	              style: 'padding: 0.5em',
	            },

	            components: [
		            {
						type: "bubble-chart-uf",
					}, {
		                type: "bubble-chart",
		            },
	            ],

	            traits: ["id"],
	          },
	        },
	    });

	    editor.DomComponents.addType("bubble-chart-uf", {
	    	model: {
	    		defaults: {
	    			tagName: "span",
	    			attributes: {
	    				id: "bubble-chart-uf",
	    				class: "bubble-chart-uf",
	    				style: "width: max-content;",
	    			},

	    			components: [
	    				{
	    					tagName: "select",
	    					attributes: {
			    				id: "bubble-chart-uf-opts",
			    				name: "bubble-chart-uf-opts",
			    				class: "bubble-chart-uf-opts",
			    			},

			    			components: [
			    				{
			    					tagName: "option",
			    					attributes: {
			    						value: "",
			    						disabled: "true",
			    						selected: "true",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "-uf-",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "30000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "30s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "60000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "60s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "120000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "2min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "300000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "600000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "Stop",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "Stop",
								            },
								        },
									],
			    				},
			    			],

			    			// traits
			    			traits: ["id"],
			    			changeProp: true,
	    				},
	    			],

	    			traits: [
	    				"id",
	    			],
			    	changeProp: true,
	    		},
	    	},
	    });

	    editor.DomComponents.addType("bubble-chart", {
	        model: {
	          defaults: {
	            tagName: "div",
	            attributes: {
	              // id: "3d-chart",
	              class: "bubble-chart",
	              // style: "width: 500px; height: 500px;",
	              'data-gjs-type': "bubble-chart",
	            },

	            components: [
	              {
	                tagName: "canvas",
	                attributes: {
	                  // id: "3d-chart",
	                  class: "bubble-chart-canvas",
	                  // style: "width: 500px; height: 500px;",
	                  'data-gjs-type': "bubble-chart-canvas",
	                },

	                "style-default": {
	                  width: '500px',
	                  height: '500px',
	                },

	                style: {
	                  width: '500px',
	                  height: '500px',
	                },
	              },
	            ],

	            script: function (props) {
	              console.log('this', this);
	              let container = this;
	              let idEl = this.id;
					const url = window.top.location.href;
					const isSubstringPresent = (url.indexOf("/editor/") !== -1 && url.indexOf("?projectId=") !== -1) || url.indexOf("/large_preview/") !== -1 || url.indexOf("/tab_preview/") !== -1 || url.indexOf("/mobile_preview/") !== -1 || url.indexOf("/fragment_editor/") !== -1;


	              const initLib = async function () {
	              	console.log('props.BaseVars', props.BaseVars);

	              	// base url bearer token taken directly from local storage after getting downloaded
					let baseUrlData, dynamicBaseUrlBearerToken, baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken;
					// getting baseUrl data from local storage for run-time access
					let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
					if (baseUrlDataFromStorage) {
						baseUrlData = JSON.parse(baseUrlDataFromStorage);
					}
					// extracting token values from base URLs from baseUrlData
					if (baseUrlData) {
						try {
							if (`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl1BearerToken = baseUrlData[`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl2BearerToken = baseUrlData[`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl3BearerToken = baseUrlData[`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl4BearerToken = baseUrlData[`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl5BearerToken = baseUrlData[`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
						} catch (e) {
							// statements
							console.log(e);
						}
					}

	              	// helper function to get value of a key in nested object
					function findKeyValue(obj, key) {
					    if (obj.hasOwnProperty(key)) {
					        // If the current object has the key, return its value
					        return obj[key];
					    }

					    for (var prop in obj) {
					        if (obj.hasOwnProperty(prop) && typeof obj[prop] === 'object') {
					            // If the current property is an object, recursively search within it
					            var result = findKeyValue(obj[prop], key);
					            if (result !== undefined) {
					                return result;
					            }
					        }
					    }
					    // Key not found in the object
					    return undefined;
					}

	                // this helper function recursively scans an object and its nests until it finds the key and returns its value
	                function findKeyInNestedObject(response, key) {
	                  let values = [];

	                  function traverseObject(obj) {
	                    for (let prop in obj) {
	                      if (typeof obj[prop] === "object") {
	                        traverseObject(obj[prop]);
	                      } else if (Array.isArray(obj[prop])) {
	                        for (let item of obj[prop]) {
	                          if (typeof item === "object") {
	                            traverseObject(item);
	                          }
	                        }
	                      } else if (prop === key) {
	                        values.push(Number(obj[prop]));
	                      }
	                    }
	                  }

	                  traverseObject(response);

	                  return values;
	                }

	                // this helper function checks if an object has multiple levels of nesting
	                function isNestedObject(response) {
	                  if (typeof response !== "object") {
	                    return false; // Not an object
	                  }

	                  for (let prop in response) {
	                    if (typeof response[prop] === "object") {
	                      return true; // Found nested object
	                    }
	                  }

	                  return false; // No nested object found
	                }

	                // this helper function checks if there is an array of objects in a response object
	                function hasArrayofObjects(obj) {
	                  for (let prop in obj) {
	                    if (
	                      Array.isArray(obj[prop]) &&
	                      obj[prop].length > 0 &&
	                      typeof obj[prop][0] === "object"
	                    ) {
	                      return true; // Array of objects found
	                    }
	                  }
	                  return false; // Array of objects not found
	                }

	                let username = props.Username;
	                let password = props.Password;
	                let apiKey = props.API_key;
	                let moreHeaders = props.More_Headers;
	                let apiMethod = props.APIMethod;
	                let apiBody = props.APIBody;

	                let Graph_API = props.CustomUrl;
	                // to rename a variable because API var is getting used in many places in this block scope
		            let API;
		            if (props.APIPath) {
		              API = props.APIPath;
		            }

	                let xAxis = [];
	                let yAxis = [];
                	let radius = [];

	                console.log("Graph props:", props, "\n\nusername:", username, "\npassword:", password, "\napiKey:", apiKey, "\nmoreHeaders:", moreHeaders );

	                // GET method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(`${Graph_API}`, config );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis, "\nradius:", radius );

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (
	                            context.type === "data" &&
	                            context.mode === "default" &&
	                            !delayed
	                          ) {
	                            delay =
	                              context.dataIndex * 300 +
	                              context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    // to populate data of dataset of bubble graph
	                    let bubbleData = [];

	                    for (let i = 0; i < xAxis.length; i++) {
	                      xAxis.length > 0 && yAxis.length > 0 && radius.length > 0 && bubbleData.push({
	                          x: xAxis[i],
	                          y: yAxis[i],
	                          r: radius[i],
	                        });
	                    }

	                    console.log("bubbleData:", bubbleData);

	                    const data = {
	                      datasets: [
	                        {
	                          label: !props.Label ? "Bubble Chart" : props.Label,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          data: bubbleData,
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bubble",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bubble-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                 			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(`${url}`, config );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );
	                      let radiusIsNested = isNestedObject(responseData[props.Radius] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(
	                            objX[!props.Abscissa ? "" : props.Abscissa]
	                          );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(
	                            objY[!props.Ordinate ? "" : props.Ordinate]
	                          );
	                        }

	                        for (let objR of apiData) {
	                          radius.push(objR[!props.Radius ? "" : props.Radius]);
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis, radius for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	let RadiusValue = props.Radius ? findKeyValue(apiData, props.Radius) : '';
	                      	console.log('## AbscissaValue, OrdinateValue, RadiusValue', AbscissaValue, OrdinateValue, RadiusValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) && props.Radius && Array.isArray(apiData[props.Radius]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];

	                          let rContainsString = apiData[props.Radius].some((element) => typeof element === "string" );
	                          radius = !rContainsString ? apiData[props.Radius] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || (responseData[props.Ordinate] === null && props.Radius && typeof responseData[props.Radius] !== "object") || responseData[props.Radius] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        //   radius.push(apiData[props.Radius]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate, Radius (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested && props.Radius && radiusIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData[props.Radius], props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) && Array.isArray(rValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || (yValue === null && typeof rValue !== "object") || rValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                            radius.push(rValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && props.Radius && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );
	                          let rValue = findKeyInNestedObject(apiData, props.Radius );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                            radius = rValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && rValue && !Array.isArray(xValue) && !Array.isArray(yValue) && !Array.isArray(rValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && typeof rValue !== 'object' || rValue === null && xValue !== 'NaN' && yValue !== 'NaN' && rValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" && typeof Number(rValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                            radius.push(Number(rValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && props.Radius && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue)) && (typeof RadiusValue === 'object' && !Array.isArray(RadiusValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length && Object.keys(OrdinateValue).length === Object.keys(RadiusValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        		radius = Object.values(RadiusValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis, "\nradius:", radius );

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (
	                            context.type === "data" &&
	                            context.mode === "default" &&
	                            !delayed
	                          ) {
	                            delay =
	                              context.dataIndex * 300 +
	                              context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    // to populate data of dataset of bubble graph
	                    let bubbleData = [];

	                    for (let i = 0; i < xAxis.length; i++) {
	                      xAxis.length > 0 && yAxis.length > 0 && radius.length > 0 && bubbleData.push({
	                          x: xAxis[i],
	                          y: yAxis[i],
	                          r: radius[i],
	                        });
	                    }

	                    console.log("bubbleData:", bubbleData);

	                    const data = {
	                      datasets: [
	                        {
	                          label: !props.Label ? "Bubble Chart" : props.Label,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          data: bubbleData,
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bubble",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bubble-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                   			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	                // POST method
	                else if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {	                        	
	                        	"Content-Type": "application/json",								
	                          	Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
							},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config@:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis, "\nradius:", radius );

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (
	                            context.type === "data" &&
	                            context.mode === "default" &&
	                            !delayed
	                          ) {
	                            delay =
	                              context.dataIndex * 300 +
	                              context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    // to populate data of dataset of bubble graph
	                    let bubbleData = [];

	                    for (let i = 0; i < xAxis.length; i++) {
	                      xAxis.length > 0 && yAxis.length > 0 && radius.length > 0 && bubbleData.push({
	                          x: xAxis[i],
	                          y: yAxis[i],
	                          r: radius[i],
	                        });
	                    }

	                    console.log("bubbleData:", bubbleData);

	                    const data = {
	                      datasets: [
	                        {
	                          label: !props.Label ? "Bubble Chart" : props.Label,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          data: bubbleData,
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bubble",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bubble-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis, "\nradius:", radius );

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (
	                            context.type === "data" &&
	                            context.mode === "default" &&
	                            !delayed
	                          ) {
	                            delay =
	                              context.dataIndex * 300 +
	                              context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    // to populate data of dataset of bubble graph
	                    let bubbleData = [];

	                    for (let i = 0; i < xAxis.length; i++) {
	                      xAxis.length > 0 && yAxis.length > 0 && radius.length > 0 && bubbleData.push({
	                          x: xAxis[i],
	                          y: yAxis[i],
	                          r: radius[i],
	                        });
	                    }

	                    console.log("bubbleData:", bubbleData);

	                    const data = {
	                      datasets: [
	                        {
	                          label: !props.Label ? "Bubble Chart" : props.Label,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          data: bubbleData,
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "bubble",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('bubble-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('bubble-chart-canvas')[0].width, container.getElementsByClassName('bubble-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('bubble-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }
	              };

	              // to update chart props as soon as window props is updated and then trigger rendering so that the chart updates
					if (!isSubstringPresent) {
				        setInterval(function () {
				          Object.keys(props).forEach(function (key) {
				            if (window[`${key}${idEl}`]) {
				              if(props[key]===window[`${key}${idEl}`]){
				                // console.log('');
				              }else{
				                props[key] = window[`${key}${idEl}`];
				               	initLib();
				              }
				            }
				          });
				        }, 500);
				    }

	              if (typeof Chart == "undefined") {
	                const script = document.createElement("script");
	                script.onload = initLib;
	                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
	                document.body.appendChild(script);
	              } else {
	                console.log("InitLib");
	                initLib();

	                let updateFrequencyValue, updateFrequencyRef;
            		let updateFrequency = (props.UpdateFrequencyDropdownID) ? document.getElementById(`${props.UpdateFrequencyDropdownID}`) : document.getElementById('bubble-chart-uf-opts');
            			
            		if (updateFrequency) {
	            		updateFrequency.addEventListener('change', (event) => {
	            			console.log('updateFrequency value:', updateFrequency.value);
	            			updateFrequencyValue = updateFrequency.value;

	            			// Clear the previous interval if it exists
						    if (updateFrequencyRef) {
						        clearInterval(updateFrequencyRef);
						    }

						    if (updateFrequencyValue !== 'Stop') {
						        // Set a new interval
						        updateFrequencyRef = setInterval(initLib, parseInt(updateFrequencyValue)); // Ensure updateFrequencyValue is a number
						    } else {
						        console.log('STOPPED & running one last time');
						        initLib();
						    }

						    console.log('updateFrequencyValue, updateFrequencyRef', updateFrequencyValue, updateFrequencyRef);
	            		});
            		}
            		
	              }
	            },

	            CustomUrl: "",
	            BaseUrl: "",
	            APIPath: "",
	            APIMethod: "GET",
	            Username: "",
	            Password: "",
	            API_Key: "",
	            More_Headers: "", // input should be like: a:b,c:d,e:f
	            APIBody: "",
	            BaseVars: options,
				projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
				options: options,

	            Animation: "",
	            Abscissa: "",
	            Ordinate: "",
	            Radius: "",
	            Bar_Colors: "",
	            Border_Width: "",
	            Border_Color: "",
	            UpdateFrequencyDropdownID: "bubble-chart-uf-opts",
	            // Fill: "",
				DisableLegend: false,

	            traits: [
	              {
	                type: "text",
	                name: "CustomUrl",
	                label: "Custom URL",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "BaseUrl",
	                label: "Base URL",
	                options: [
	                  { id: "baseUrl1", name: "Base URL #1" },
	                  { id: "baseUrl2", name: "Base URL #2" },
	                  { id: "baseUrl3", name: "Base URL #3" },
	                  { id: "baseUrl4", name: "Base URL #4" },
	                  { id: "baseUrl5", name: "Base URL #5" },
	                  { id: "null", name: "No Base URL" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIPath",
	                label: "API Path",
	                placeholder: "Don't start with '/'",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "APIMethod",
	                label: "API Method",
	                options: [
	                  { id: "GET", name: "GET" },
	                  { id: "POST", name: "POST" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Username",
	                label: "Username",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Password",
	                label: "Password",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "API_Key",
	                label: "API Key",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "More_Headers",
	                label: "More Headers",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIBody",
	                label: "API Body",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "Animation",
	                label: "Pre-defined Graph Animations",
	                options: [
	                  { id: "delay", name: "Delay" },
	                  { id: "hideAndShow", name: "Hide And Show" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Abscissa",
	                label: "Abscissa",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Ordinate",
	                label: "Ordinates",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Radius",
	                label: "Radius",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Bar_Colors",
	                label: "Datapoint Colors",
	                changeProp: true,
	              },
	              {
	                type: "range",
	                min: "0",
	                max: "20",
	                name: "Border_Width",
	                label: "Border Width [0px to 20px]",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Border_Color",
	                label: "Border Color",
	                changeProp: true,
	              },
		            {
		                type: "text",
		                name: "UpdateFrequencyDropdownID",
		                label: "UpdateFrequency Dropdown ID",
		                placeholder: "For example: bubble-chart-uf-opts",
		                changeProp: true,
		            },
	              // {
	              //     type: 'checkbox',
	              //     name: 'Fill',
	              //     label: 'Fill Area',
	              //     changeProp: true,
	              // },
				  {
	                  type: 'checkbox',
	                  name: 'DisableLegend',
	                  label: 'Disable Legend',
	                  changeProp: true,
	              },
	            ],

	            changeProp: true,

	            "script-props": [
	              "CustomUrl",
	              "BaseUrl",
	              "APIPath",
	              "APIMethod",
	              "BaseVars",
	              "API_HOST",
	              "projectId",
	              "Username",
	              "Password",
	              "API_Key",
	              "More_Headers",	             
	              "APIBody",
	              "Animation",
	              "Abscissa",
	              "Ordinate",
	              "Radius",
	              "Bar_Colors",
	              "Border_Width",
	              "Border_Color",
	              "UpdateFrequencyDropdownID",
				  "options",
				  "DisableLegend",
	            ],
	          },
	        },

	        isComponent: (el) => {
	          if (
	            el.getAttribute &&
	            el.getAttribute("data-gjs-type") == "bubble-chart"
	          ) {
	            return "bubble-chart";
	          }
	        },
	        view: defaultView.extend({
	          init({ model }) {},
	        }),
	    });

		// 2D DOUGHNUT CHART
	    editor.DomComponents.addType('doughnut-chart-container', {
	        model: {
	          defaults: {
	            tagName: 'div',
	            attributes: {
	              class: "doughnut-chart-container",
	              style: 'padding: 0.5em',
	            },

	            components: [
		            {
						type: "doughnut-chart-uf",
					}, {
		                type: "doughnut-chart",
		            },
	            ],

	            traits: ["id"],
	          },
	        },
	    });

	    editor.DomComponents.addType("doughnut-chart-uf", {
	    	model: {
	    		defaults: {
	    			tagName: "span",
	    			attributes: {
	    				id: "doughnut-chart-uf",
	    				class: "doughnut-chart-uf",
	    				style: "width: max-content;",
	    			},

	    			components: [
	    				{
	    					tagName: "select",
	    					attributes: {
			    				id: "doughnut-chart-uf-opts",
			    				name: "doughnut-chart-uf-opts",
			    				class: "doughnut-chart-uf-opts",
			    			},

			    			components: [
			    				{
			    					tagName: "option",
			    					attributes: {
			    						value: "",
			    						disabled: "true",
			    						selected: "true",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "-uf-",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "30000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "30s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "60000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "60s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "120000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "2min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "300000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "600000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "Stop",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "Stop",
								            },
								        },
									],
			    				},
			    			],

			    			// traits
			    			traits: ["id"],
			    			changeProp: true,
	    				},
	    			],

	    			traits: [
	    				"id",
	    			],
			    	changeProp: true,
	    		},
	    	},
	    });

	    editor.DomComponents.addType("doughnut-chart", {
	        model: {
	          defaults: {
	            tagName: "div",
	            attributes: {
	              // id: "3d-chart",
	              class: "doughnut-chart",
	              // style: "width: 500px; height: 500px;",
	              'data-gjs-type': "doughnut-chart",
	            },

	            components: [
	              {
	                tagName: "canvas",
	                attributes: {
	                  // id: "3d-chart",
	                  class: "doughnut-chart-canvas",
	                  // style: "width: 500px; height: 500px;",
	                  'data-gjs-type': "doughnut-chart-canvas",
	                },

	                "style-default": {
	                  width: '500px',
	                  height: '500px',
	                },

	                style: {
	                  width: '500px',
	                  height: '500px',
	                },
	              },
	            ],

	            script: function (props) {
	              console.log('this', this);
	              let container = this;
					let idEl = this.id;
					const url = window.top.location.href;
					const isSubstringPresent = (url.indexOf("/editor/") !== -1 && url.indexOf("?projectId=") !== -1) || url.indexOf("/large_preview/") !== -1 || url.indexOf("/tab_preview/") !== -1 || url.indexOf("/mobile_preview/") !== -1 || url.indexOf("/fragment_editor/") !== -1;

	              const initLib = async function () {
	              	console.log('props.BaseVars', props.BaseVars);

	              	// base url bearer token taken directly from local storage after getting downloaded
					let baseUrlData, dynamicBaseUrlBearerToken, baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken;
					// getting baseUrl data from local storage for run-time access
					let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
					if (baseUrlDataFromStorage) {
						baseUrlData = JSON.parse(baseUrlDataFromStorage);
					}
					// extracting token values from base URLs from baseUrlData
					if (baseUrlData) {
						try {
							if (`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl1BearerToken = baseUrlData[`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl2BearerToken = baseUrlData[`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl3BearerToken = baseUrlData[`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl4BearerToken = baseUrlData[`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl5BearerToken = baseUrlData[`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
						} catch (e) {
							// statements
							console.log(e);
						}
					}

	              	// helper function to get value of a key in nested object
					function findKeyValue(obj, key) {
					    if (obj.hasOwnProperty(key)) {
					        // If the current object has the key, return its value
					        return obj[key];
					    }

					    for (var prop in obj) {
					        if (obj.hasOwnProperty(prop) && typeof obj[prop] === 'object') {
					            // If the current property is an object, recursively search within it
					            var result = findKeyValue(obj[prop], key);
					            if (result !== undefined) {
					                return result;
					            }
					        }
					    }
					    // Key not found in the object
					    return undefined;
					}

	                // this helper function recursively scans an object and its nests until it finds the key and returns its value
	                function findKeyInNestedObject(response, key) {
	                  let values = [];

	                  function traverseObject(obj) {
	                    for (let prop in obj) {
	                      if (typeof obj[prop] === "object") {
	                        traverseObject(obj[prop]);
	                      } else if (Array.isArray(obj[prop])) {
	                        for (let item of obj[prop]) {
	                          if (typeof item === "object") {
	                            traverseObject(item);
	                          }
	                        }
	                      } else if (prop === key) {
	                        values.push(Number(obj[prop]));
	                      }
	                    }
	                  }

	                  traverseObject(response);

	                  return values;
	                }

	                // this helper function checks if an object has multiple levels of nesting
	                function isNestedObject(response) {
	                  if (typeof response !== "object") {
	                    return false; // Not an object
	                  }

	                  for (let prop in response) {
	                    if (typeof response[prop] === "object") {
	                      return true; // Found nested object
	                    }
	                  }

	                  return false; // No nested object found
	                }

	                // this helper function checks if there is an array of objects in a response object
	                function hasArrayofObjects(obj) {
	                  for (let prop in obj) {
	                    if (
	                      Array.isArray(obj[prop]) &&
	                      obj[prop].length > 0 &&
	                      typeof obj[prop][0] === "object"
	                    ) {
	                      return true; // Array of objects found
	                    }
	                  }
	                  return false; // Array of objects not found
	                }

	                let username = props.Username;
	                let password = props.Password;
	                let apiKey = props.API_key;
	                let moreHeaders = props.More_Headers;
	                let apiMethod = props.APIMethod;
	                let apiBody = props.APIBody;

	                let Graph_API = props.CustomUrl;
	                // to rename a variable because API var is getting used in many places in this block scope
		            let API;
		            if (props.APIPath) {
		              API = props.APIPath;
		            }

	                let xAxis = [];
	                let yAxis = [];

	                console.log("Graph props:", props, "\n\nusername:", username, "\npassword:", password, "\napiKey:", apiKey, "\nmoreHeaders:", moreHeaders );

	                // GET method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "doughnut",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('doughnut-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
	       			 		
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "doughnut",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('doughnut-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	                // POST method
	                else if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {	                        	
	                        	"Content-Type": "application/json",								
	                          	Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
							},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config@:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "doughnut",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('doughnut-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                   			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
	       			 		
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "doughnut",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('doughnut-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('doughnut-chart-canvas')[0].width, container.getElementsByClassName('doughnut-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('doughnut-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }
	              };

	              // to update chart props as soon as window props is updated and then trigger rendering so that the chart updates
					if (!isSubstringPresent) {
				        setInterval(function () {
				          Object.keys(props).forEach(function (key) {
				            if (window[`${key}${idEl}`]) {
				              if(props[key]===window[`${key}${idEl}`]){
				                // console.log('');
				              }else{
				                props[key] = window[`${key}${idEl}`];
				               	initLib();
				              }
				            }
				          });
				        }, 500);
				    }

	              if (typeof Chart == "undefined") {
	                const script = document.createElement("script");
	                script.onload = initLib;
	                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
	                document.body.appendChild(script);
	              } else {
	                console.log("InitLib");
	                initLib();

	                let updateFrequencyValue, updateFrequencyRef;
            		let updateFrequency = (props.UpdateFrequencyDropdownID) ? document.getElementById(`${props.UpdateFrequencyDropdownID}`) : document.getElementById('doughnut-chart-uf-opts');
            			
            		if (updateFrequency) {
	            		updateFrequency.addEventListener('change', (event) => {
	            			console.log('updateFrequency value:', updateFrequency.value);
	            			updateFrequencyValue = updateFrequency.value;

	            			// Clear the previous interval if it exists
						    if (updateFrequencyRef) {
						        clearInterval(updateFrequencyRef);
						    }

						    if (updateFrequencyValue !== 'Stop') {
						        // Set a new interval
						        updateFrequencyRef = setInterval(initLib, parseInt(updateFrequencyValue)); // Ensure updateFrequencyValue is a number
						    } else {
						        console.log('STOPPED & running one last time');
						        initLib();
						    }

						    console.log('updateFrequencyValue, updateFrequencyRef', updateFrequencyValue, updateFrequencyRef);
	            		});
            		}
            		
	              }
	            },

	            CustomUrl: "",
	            BaseUrl: "",
	            APIPath: "",
	            APIMethod: "GET",
	            Username: "",
	            Password: "",
	            API_Key: "",
	            More_Headers: "", // input should be like: a:b,c:d,e:f
	            APIBody: "",
	            BaseVars: options,
	            API_HOST: API_HOST,
				projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
				options: options,

	            Animation: "",
	            Abscissa: "",
	            Ordinate: "",
	            Bar_Colors: "",
	            Border_Width: "",
	            Border_Color: "",
	            UpdateFrequencyDropdownID: "doughnut-chart-uf-opts",
	            // Fill: "",
				DisableLegend: false,

	            traits: [
	              {
	                type: "text",
	                name: "CustomUrl",
	                label: "Custom URL",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "BaseUrl",
	                label: "Base URL",
	                options: [
	                  { id: "baseUrl1", name: "Base URL #1" },
	                  { id: "baseUrl2", name: "Base URL #2" },
	                  { id: "baseUrl3", name: "Base URL #3" },
	                  { id: "baseUrl4", name: "Base URL #4" },
	                  { id: "baseUrl5", name: "Base URL #5" },
	                  { id: "null", name: "No Base URL" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIPath",
	                label: "API Path",
	                placeholder: "Don't start with '/'",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "APIMethod",
	                label: "API Method",
	                options: [
	                  { id: "GET", name: "GET" },
	                  { id: "POST", name: "POST" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Username",
	                label: "Username",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Password",
	                label: "Password",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "API_Key",
	                label: "API Key",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "More_Headers",
	                label: "More Headers",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIBody",
	                label: "API Body",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "Animation",
	                label: "Pre-defined Graph Animations",
	                options: [
	                  { id: "delay", name: "Delay" },
	                  { id: "hideAndShow", name: "Hide And Show" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Abscissa",
	                label: "Abscissa",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Ordinate",
	                label: "Ordinates",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Bar_Colors",
	                label: "Datapoint Colors",
	                changeProp: true,
	              },
	              {
	                type: "range",
	                min: "0",
	                max: "20",
	                name: "Border_Width",
	                label: "Border Width [0px to 20px]",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Border_Color",
	                label: "Border Color",
	                changeProp: true,
	              },
		            {
		                type: "text",
		                name: "UpdateFrequencyDropdownID",
		                label: "UpdateFrequency Dropdown ID",
		                placeholder: "For example: doughnut-chart-uf-opts",
		                changeProp: true,
		            },
	              // {
	              //     type: 'checkbox',
	              //     name: 'Fill',
	              //     label: 'Fill Area',
	              //     changeProp: true,
	              // },
				  {
	                  type: 'checkbox',
	                  name: 'DisableLegend',
	                  label: 'Disable Legend',
	                  changeProp: true,
	              },
	            ],

	            changeProp: true,

	            "script-props": [
	              "CustomUrl",
	              "BaseUrl",
	              "APIPath",
	              "APIMethod",
	              "BaseVars",
	              "API_HOST",
	              "projectId",
	              "Username",
	              "Password",
	              "API_Key",
	              "More_Headers",	             
	              "APIBody",
	              "Animation",
	              "Abscissa",
	              "Ordinate",
	              "Bar_Colors",
	              "Border_Width",
	              "Border_Color",
	              "UpdateFrequencyDropdownID",
				  "options",
				  "DisableLegend",
	            ],
	          },
	        },

	        isComponent: (el) => {
	          if (
	            el.getAttribute &&
	            el.getAttribute("data-gjs-type") == "doughnut-chart"
	          ) {
	            return "doughnut-chart";
	          }
	        },
	        view: defaultView.extend({
	          init({ model }) {},
	        }),
	    });

		// 2D PIE CHART
	    editor.DomComponents.addType('pie-chart-container', {
	        model: {
	          defaults: {
	            tagName: 'div',
	            attributes: {
	              class: "pie-chart-container",
	              style: 'padding: 0.5em',
	            },

	            components: [
		            {
						type: "pie-chart-uf",
					}, {
		                type: "pie-chart",
		            },
	            ],

	            traits: ["id"],
	          },
	        },
	    });

	    editor.DomComponents.addType("pie-chart-uf", {
	    	model: {
	    		defaults: {
	    			tagName: "span",
	    			attributes: {
	    				id: "pie-chart-uf",
	    				class: "pie-chart-uf",
	    				style: "width: max-content;",
	    			},

	    			components: [
	    				{
	    					tagName: "select",
	    					attributes: {
			    				id: "pie-chart-uf-opts",
			    				name: "pie-chart-uf-opts",
			    				class: "pie-chart-uf-opts",
			    			},

			    			components: [
			    				{
			    					tagName: "option",
			    					attributes: {
			    						value: "",
			    						disabled: "true",
			    						selected: "true",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "-uf-",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "30000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "30s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "60000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "60s",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "120000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "2min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "300000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "5min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "600000",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "10min",
								            },
								        },
									],
			    				}, {
			    					tagName: "option",
			    					attributes: {
			    						value: "Stop",
			    					},

			    					components: [
										{
								            tagName: "p",
								            type: "text",
								            editable: true,

								            components: {
								                type: "textnode",
								                content: "Stop",
								            },
								        },
									],
			    				},
			    			],

			    			// traits
			    			traits: ["id"],
			    			changeProp: true,
	    				},
	    			],

	    			traits: [
	    				"id",
	    			],
			    	changeProp: true,
	    		},
	    	},
	    });

	    editor.DomComponents.addType("pie-chart", {
	        model: {
	          defaults: {
	            tagName: "div",
	            attributes: {
	              // id: "3d-chart",
	              class: "pie-chart",
	              // style: "width: 500px; height: 500px;",
	              'data-gjs-type': "pie-chart",
	            },

	            components: [
	              {
	                tagName: "canvas",
	                attributes: {
	                  // id: "3d-chart",
	                  class: "pie-chart-canvas",
	                  // style: "width: 500px; height: 500px;",
	                  'data-gjs-type': "pie-chart-canvas",
	                },

	                "style-default": {
	                  width: '500px',
	                  height: '500px',
	                },

	                style: {
	                  width: '500px',
	                  height: '500px',
	                },
	              },
	            ],

	            script: function (props) {
	              console.log('this', this);
	              let container = this;
	              let idEl = this.id;
					const url = window.top.location.href;
					const isSubstringPresent = (url.indexOf("/editor/") !== -1 && url.indexOf("?projectId=") !== -1) || url.indexOf("/large_preview/") !== -1 || url.indexOf("/tab_preview/") !== -1 || url.indexOf("/mobile_preview/") !== -1 || url.indexOf("/fragment_editor/") !== -1;


	              const initLib = async function () {
	              	console.log('props.BaseVars', props.BaseVars);

	              	// base url bearer token taken directly from local storage after getting downloaded
					let baseUrlData, dynamicBaseUrlBearerToken, baseUrl1BearerToken, baseUrl2BearerToken, baseUrl3BearerToken, baseUrl4BearerToken, baseUrl5BearerToken;
					// getting baseUrl data from local storage for run-time access
					let baseUrlDataFromStorage = localStorage.getItem("baseUrlData");
					if (baseUrlDataFromStorage) {
						baseUrlData = JSON.parse(baseUrlDataFromStorage);
					}
					// extracting token values from base URLs from baseUrlData
					if (baseUrlData) {
						try {
							if (`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl1BearerToken = baseUrlData[`baseUrl1_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl2BearerToken = baseUrlData[`baseUrl2_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl3BearerToken = baseUrlData[`baseUrl3_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl4BearerToken = baseUrlData[`baseUrl4_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
							if (`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}` in baseUrlData) {
								baseUrl5BearerToken = baseUrlData[`baseUrl5_${props.projectId ? props.projectId : props.options.projectId}`].token;
							}
						} catch (e) {
							// statements
							console.log(e);
						}
					}

	              	// helper function to get value of a key in nested object
					function findKeyValue(obj, key) {
					    if (obj.hasOwnProperty(key)) {
					        // If the current object has the key, return its value
					        return obj[key];
					    }

					    for (var prop in obj) {
					        if (obj.hasOwnProperty(prop) && typeof obj[prop] === 'object') {
					            // If the current property is an object, recursively search within it
					            var result = findKeyValue(obj[prop], key);
					            if (result !== undefined) {
					                return result;
					            }
					        }
					    }
					    // Key not found in the object
					    return undefined;
					}

	                // this helper function recursively scans an object and its nests until it finds the key and returns its value
	                function findKeyInNestedObject(response, key) {
	                  let values = [];

	                  function traverseObject(obj) {
	                    for (let prop in obj) {
	                      if (typeof obj[prop] === "object") {
	                        traverseObject(obj[prop]);
	                      } else if (Array.isArray(obj[prop])) {
	                        for (let item of obj[prop]) {
	                          if (typeof item === "object") {
	                            traverseObject(item);
	                          }
	                        }
	                      } else if (prop === key) {
	                        values.push(Number(obj[prop]));
	                      }
	                    }
	                  }

	                  traverseObject(response);

	                  return values;
	                }

	                // this helper function checks if an object has multiple levels of nesting
	                function isNestedObject(response) {
	                  if (typeof response !== "object") {
	                    return false; // Not an object
	                  }

	                  for (let prop in response) {
	                    if (typeof response[prop] === "object") {
	                      return true; // Found nested object
	                    }
	                  }

	                  return false; // No nested object found
	                }

	                // this helper function checks if there is an array of objects in a response object
	                function hasArrayofObjects(obj) {
	                  for (let prop in obj) {
	                    if (
	                      Array.isArray(obj[prop]) &&
	                      obj[prop].length > 0 &&
	                      typeof obj[prop][0] === "object"
	                    ) {
	                      return true; // Array of objects found
	                    }
	                  }
	                  return false; // Array of objects not found
	                }

	                let username = props.Username;
	                let password = props.Password;
	                let apiKey = props.API_key;
	                let moreHeaders = props.More_Headers;
	                let apiMethod = props.APIMethod;
	                let apiBody = props.APIBody;

	                let Graph_API = props.CustomUrl;
	                // to rename a variable because API var is getting used in many places in this block scope
		            let API;
		            if (props.APIPath) {
		              API = props.APIPath;
		            }

	                let xAxis = [];
	                let yAxis = [];

	                console.log("Graph props:", props, "\n\nusername:", username, "\npassword:", password, "\napiKey:", apiKey, "\nmoreHeaders:", moreHeaders );

	                // GET method
	                if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "pie",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('pie-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
							myChart.clear();
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
								myChart.clear();
							  	myChart.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated 1');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'GET') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                       	// just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                        headers: {},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "pie",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('pie-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}	                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }

	                // POST method
	                else if (Graph_API && (!props.BaseUrl || props.BaseUrl === 'null') && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {	                        	
	                        	"Content-Type": "application/json",								
	                          	Authorization: "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${Graph_API}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
							},
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config@:", config);

	                      let response = await fetch(`${Graph_API}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "pie",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('pie-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                } else if (props.BaseUrl && API && !Graph_API && apiMethod === 'POST') {
	                  try {
	                    // By Invoice URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&INVOICE=AR25634D', {

	                    // By Date URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&DATE=20230102', {

	                    // By Customer URL
	                    // let response = await fetch('http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&CUSTOMER=DENCO%20EQUIPMENTS%20LIMITED', {

	                    // By Coin URL
	                    // let response = await fetch('https://api.coinranking.com/v2/coins', {

	                    // By Month URL
	                    // http://0.0.0.0:8080/183.82.1.220:8000/wem_invoice/invoice?sap-client=800&MONTH=MAR

	                  	// concatenating base url and its remaining part
			              let url, baseUrlBearerToken;
			              let forDownloadUrl;
			              if (props.BaseUrl === 'baseUrl1') {
			                url = props.BaseVars.baseUrl1 + API;
							forDownloadUrl = "{{API_URL1}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl1BearerToken;
			                baseUrlBearerToken = baseUrl1BearerToken;
			              } else if (props.BaseUrl === 'baseUrl2') {
			                url = props.BaseVars.baseUrl2 + API;
							forDownloadUrl = "{{API_URL2}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl2BearerToken;
			                baseUrlBearerToken = baseUrl2BearerToken;
			              } else if (props.BaseUrl === 'baseUrl3') {
			                url = props.BaseVars.baseUrl3 + API;
							forDownloadUrl = "{{API_URL3}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl3BearerToken;
			                baseUrlBearerToken = baseUrl3BearerToken;
			              } else if (props.BaseUrl === 'baseUrl4') {
			                url = props.BaseVars.baseUrl4 + API;
							forDownloadUrl = "{{API_URL4}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl4BearerToken;
			                baseUrlBearerToken = baseUrl4BearerToken;
			              } else if (props.BaseUrl === 'baseUrl5') {
			                url = props.BaseVars.baseUrl5 + API;
							forDownloadUrl = "{{API_URL5}}" + API;
			                // baseUrlBearerToken = props.BaseVars.baseUrl5BearerToken;
			                baseUrlBearerToken = baseUrl5BearerToken;
			              }

			              const urlDownload = window.top.location.href;
			              const isSubstringPresent = (urlDownload.indexOf("/editor/") !== -1 && urlDownload.indexOf("?projectId=") !== -1) || urlDownload.indexOf("/large_preview/") !== -1 || urlDownload.indexOf("/tab_preview/") !== -1 || urlDownload.indexOf("/mobile_preview/") !== -1 || urlDownload.indexOf("/fragment_editor/") !== -1;
	       			 		if (!isSubstringPresent) {
	       			 			// running in download
	       			 			url = forDownloadUrl;
	       			 		}
			              console.log('url, baseUrlBearerToken', url, baseUrlBearerToken);

	                    // when api, username and password is provided but not api key
	                    if (username && password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait, if provided
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      const response = await fetch(
	                        `${url}`,
	                        config
	                      );

	                      const responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and api key is provided but not username and password
	                    else if (!username && !password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api and baseUrlBearerToken is provided but not username and password
	                    else if (baseUrlBearerToken && !username && !password && !apiKey) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          "Authorization": `Bearer ${baseUrlBearerToken}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log(
	                        "responseData:",
	                        responseData,
	                        "\napiData:",
	                        apiData
	                      );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when everything is provided
	                    else if (username && password && apiKey !== undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                          Authorization:
	                            "Basic " + btoa(username + ":" + password),
	                          	"X-API-KEY": `${apiKey}`,
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(responseData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(responseData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    // when api is provided but nothing else is provided
	                    else if (!username && !password && apiKey === undefined) {
	                      let apiData;
	                      let config = {
	                      	method: "POST",
	                      	body: apiBody,
	                        headers: {
	                        	"Content-Type": "application/json",
	                        },
	                      };
	                      // ['a:b', "c:d"]
	                      // extracting headers from More_Headers trait
	                      if (moreHeaders) {
	                        moreHeaders.split(",").forEach((header) => {
	                          let key, val;
	                          [key, val] = header.split(":");
	                          console.log("[key, val]:\n", key, val);

	                          config.headers[key] = val;
	                        });
	                      }

	                      console.log("config:", config);

	                      let response = await fetch(`${url}`, config);

	                      let responseData = await response.json();
	                      apiData = responseData;
	                      console.log("responseData:", responseData, "\napiData:", apiData );

	                      // variables needed later confirming whether the value of the required keys are nested further with objects or not
	                      let hasNestedArrayOfObjects = hasArrayofObjects(apiData);
	                      let abscissaIsNested = isNestedObject(apiData[props.Abscissa] );
	                      let ordinateIsNested = isNestedObject(apiData[props.Ordinate] );

	                      // MAKING IT WORK FOR UNIVERSAL API RESPONSES, below;
	                      // not for response structures - array of arrays, object of array of objects, object of array of arrays

	                      // checking if the reponse is an ARRAY of OBNECTS; and then creating the coordinates array xAxis, yAxis for plotting
	                      if (Array.isArray(apiData) && apiData.length > 0 && typeof apiData[0] === "object" ) {
	                        for (let objX of apiData) {
	                          xAxis.push(objX[!props.Abscissa ? "" : props.Abscissa] );
	                        }

	                        for (let objY of apiData) {
	                          yAxis.push(objY[!props.Ordinate ? "" : props.Ordinate] );
	                        }
	                      }

	                      // checking if the reponse is an OBJECT but not an array; and then creating the coordinates array xAxis, yAxis for plotting
	                      else if (typeof apiData === "object" && !Array.isArray(apiData) ) {
	                        // just checking if props are provided, to handle errors
	                      	let AbscissaValue = props.Abscissa ? findKeyValue(apiData, props.Abscissa) : '';
	                      	let OrdinateValue = props.Ordinate ? findKeyValue(apiData, props.Ordinate) : '';
	                      	console.log('## AbscissaValue, OrdinateValue', AbscissaValue, OrdinateValue);

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are an ARRAY also while those traits/values are not 'undefined'
	                        if (!hasNestedArrayOfObjects && props.Abscissa && Array.isArray(apiData[props.Abscissa]) && props.Ordinate && Array.isArray(apiData[props.Ordinate]) ) {
	                          // if the array contains a string amongst numbers, then don't assign it to the coordinate arrays
	                          let xContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          xAxis = !xContainsString ? apiData[props.Abscissa] : [];

	                          let yContainsString = apiData[props.Abscissa].some((element) => typeof element === "string" );
	                          yAxis = !yContainsString ? apiData[props.Ordinate] : [];
	                        }

	                        // now checking if the value of the required keys are PRIMITIVE values, neither arrays nor objects also while those traits/values are not 'undefined'
	                        // else if ((!hasNestedArrayOfObjects && props.Abscissa && typeof apiData[props.Abscissa] !== "object") || (apiData[props.Abscissa] === null && props.Ordinate && typeof responseData[props.Ordinate] !== "object") || responseData[props.Ordinate] === null ) {
	                        //   xAxis.push(apiData[props.Abscissa]);
	                        //   yAxis.push(apiData[props.Ordinate]);
	                        // }

	                        // now checking if the value of the required keys - Abscissa, Ordinate (entered in the trait) are again a NESTED OBJECT (using recursive helper function) also while those traits/values are not 'undefined'
	                        else if (!hasNestedArrayOfObjects && props.Abscissa && abscissaIsNested && props.Ordinate && ordinateIsNested ) {
	                          console.log("inside 1");
	                          let xValue = findKeyInNestedObject(apiData[props.Abscissa], props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData[props.Ordinate], props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          else if ((xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== "object") || (xValue === null && typeof yValue !== "object") || yValue === null ) {
	                            xAxis.push(xValue);
	                            yAxis.push(yValue);
	                          }
	                        }

	                        // now checking if the value of the response is nested also while those traits/values are not 'undefined'
	                        else if (props.Abscissa && props.Ordinate && hasNestedArrayOfObjects ) {
	                          console.log("inside 2");
	                          let xValue = findKeyInNestedObject(apiData, props.Abscissa );
	                          let yValue = findKeyInNestedObject(apiData, props.Ordinate );

	                          // if the value of the nested key is an ARRAY, then assign them to the coordinate array
	                          if (xValue && yValue && Array.isArray(xValue) && Array.isArray(yValue) ) {
	                            xAxis = xValue;
	                            yAxis = yValue;
	                          }

	                          // if the value of the nested key is a PRIMITIVE value alone, then push them in the coordinate array
	                          // else if (xValue && yValue && !Array.isArray(xValue) && !Array.isArray(yValue) && typeof xValue !== 'object' || xValue === null && typeof yValue !== 'object' || yValue === null && xValue !== 'NaN' && yValue !== 'NaN') {
	                          else if (typeof Number(xValue) === "number" && typeof Number(yValue) === "number" ) {
	                            xAxis.push(Number(xValue));
	                            yAxis.push(Number(yValue));
	                          }
	                        }

	                        // now checking if Abscissa and Ordinates both are objects and then plotting their key-value pairs
	                        else if (props.Abscissa && props.Ordinate && (typeof AbscissaValue === 'object' && !Array.isArray(AbscissaValue)) && (typeof OrdinateValue === 'object' && !Array.isArray(OrdinateValue))) {
	                        	console.log('###');
	                        	// if both their lengths are equal, then plot
	                        	if (Object.keys(AbscissaValue).length === Object.keys(OrdinateValue).length) {
	                        		xAxis = Object.values(AbscissaValue);
	                        		yAxis = Object.values(OrdinateValue);
	                        	}
	                        }
	                      }
	                    }

	                    console.log("xAxis:", xAxis, "\nyAxis:", yAxis);

	                    // const labels = [
	                    //   "January",
	                    //   "February",
	                    //   "March",
	                    //   "April",
	                    //   "May",
	                    //   "June",
	                    // ];

	                    // animations
	                    let animate;
	                    let transition;
	                    let delayed;

	                    if (props.Animation === "delay") {
	                      animate = {
	                        onComplete: () => {
	                          delayed = true;
	                        },

	                        delay: (context) => {
	                          let delay = 0;
	                          if (context.type === "data" && context.mode === "default" && !delayed ) {
	                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
	                          }
	                          return delay;
	                        },
	                      };
	                    } else if (props.Animation === "hideAndShow") {
	                      animate = {};
	                      transition = {
	                        show: {
	                          animations: {
	                            x: {
	                              from: 0,
	                            },
	                            y: {
	                              from: 0,
	                            },
	                          },
	                        },

	                        hide: {
	                          animations: {
	                            x: {
	                              to: 0,
	                            },
	                            y: {
	                              to: 0,
	                            },
	                          },
	                        },
	                      };
	                    }

	                    const data = {
	                      // x-axis
	                      labels: xAxis,
	                      datasets: [
	                        {
	                          label: props.Abscissa,
	                          // backgroundColor: ['red', 'green', 'blue'],
	                          backgroundColor: !props.Bar_Colors ? ["red", "green", "blue"] : props.Bar_Colors.split(","),
	                          borderColor: !props.Border_Color ? "rgb(255, 99, 132)" : props.Border_Color,
	                          borderWidth: !props.Border_Width ? 2 : props.Border_Width,
	                          // y-axis
	                          data: yAxis,
	                          // color: ['red', 'green', 'blue'],
	                        },
	                      ],
	                    };

	                    const config = {
	                      type: "pie",
	                      data: data,
	                      options: {
	                        animation: animate,
	                        transitions: transition,
	                        stacked: false,
	                        responsive: true,
							plugins: {
								legend: {
									display: !props.DisableLegend,
								},
							},
	                      },
	                    };

	                    let myChart;
	                    const ctx = container.getElementsByClassName('pie-chart-canvas')[0].getContext("2d");
	                    
	                    // if (ctx) {
	                    // 	const hasContent = ctx.getImageData(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height).data.some(value => value !== 0);
	                    	
	                    // 	if (hasContent) {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	} else {
	                    // 		console.log('hasContent', hasContent);
	                    // 		if (myChart) {
	                    // 			console.log('1');
	                    // 			myChart.destroy();
	                    // 			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
	                    // 			myChart = new Chart(ctx, config);
	                    // 		} else {
	                    // 			console.log('2');
	                    // 			let chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
	                    // 			console.log('chartStatus', chartStatus);
	                    // 			if (chartStatus != undefined) {
						// 			  	chartStatus.destroy();
						// 			  	myChart = new Chart(ctx, config);
						// 			} else {
						// 				myChart = new Chart(ctx, config);
						// 			}	                    			
	                    // 		}
	                    // 	}
	                    // }
	                    
	                    if (myChart) {
                			console.log('1');
                			myChart.destroy();
                			ctx.clearRect(0, 0, container.getElementsByClassName('pie-chart-canvas')[0].width, container.getElementsByClassName('pie-chart-canvas')[0].height);
                			myChart = new Chart(ctx, config);
                			console.log('Chart updated');
                		} else {
                			console.log('2');
                			let chartStatus;
                			if (chartStatus) {
                				chartStatus = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
                			}
                			console.log('chartStatus', chartStatus);
                			if (chartStatus != undefined) {
							  	chartStatus.destroy();
							  	myChart = new Chart(ctx, config);
                				console.log('Chart updated');
							} else {
								const existingChart = Chart.getChart(`${container.getElementsByClassName('pie-chart-canvas')[0].id}`);
								// console.log('existingChart 1', existingChart);
								if (existingChart) {
									existingChart.destroy();
								}
								// console.log('existingChart 2', existingChart);
								// myChart.clear();
							  	// myChart.destroy();
								myChart = new Chart(ctx, config);
                				console.log('Chart updated 2');
							}                    			
                		}
	                  } catch (e) {
	                    console.log(e);
	                  }
	                }
	              };
	              
	                // to update chart props as soon as window props is updated and then trigger rendering so that the chart updates
					if (!isSubstringPresent) {
				        setInterval(function () {
				          Object.keys(props).forEach(function (key) {
				            if (window[`${key}${idEl}`]) {
				              if(props[key]===window[`${key}${idEl}`]){
				                // console.log('');
				              }else{
				                props[key] = window[`${key}${idEl}`];
				               	initLib();
				              }
				            }
				          });
				        }, 500);
				    }

	              if (typeof Chart == "undefined") {
	                const script = document.createElement("script");
	                script.onload = initLib;
	                script.src = "https://cdn.jsdelivr.net/npm/chart.js";
	                document.body.appendChild(script);
	              } else {
	                console.log("InitLib");
	                initLib();

	                let updateFrequencyValue, updateFrequencyRef;
            		let updateFrequency = (props.UpdateFrequencyDropdownID) ? document.getElementById(`${props.UpdateFrequencyDropdownID}`) : document.getElementById('pie-chart-uf-opts');
            			
            		if (updateFrequency) {
	            		updateFrequency.addEventListener('change', (event) => {
	            			console.log('updateFrequency value:', updateFrequency.value);
	            			updateFrequencyValue = updateFrequency.value;

	            			// Clear the previous interval if it exists
						    if (updateFrequencyRef) {
						        clearInterval(updateFrequencyRef);
						    }

						    if (updateFrequencyValue !== 'Stop') {
						        // Set a new interval
						        updateFrequencyRef = setInterval(initLib, parseInt(updateFrequencyValue)); // Ensure updateFrequencyValue is a number
						    } else {
						        console.log('STOPPED & running one last time');
						        initLib();
						    }

						    console.log('updateFrequencyValue, updateFrequencyRef', updateFrequencyValue, updateFrequencyRef);
	            		});
            		}
            		
	              }
	            },

	            CustomUrl: "",
	            BaseUrl: "",
	            APIPath: "",
	            APIMethod: "GET",
	            Username: "",
	            Password: "",
	            API_Key: "",
	            More_Headers: "", // input should be like: a:b,c:d,e:f
	            APIBody: "",
	            BaseVars: options,
	            API_HOST: API_HOST,
				projectId: localStorage.getItem("project_id") ? localStorage.getItem("project_id") : "",
				options: options,

	            Animation: "",
	            Abscissa: "",
	            Ordinate: "",
	            Bar_Colors: "",
	            Border_Width: "",
	            Border_Color: "",
	            UpdateFrequencyDropdownID: "pie-chart-uf-opts",
	            // Fill: "",
				DisableLegend: false,

	            traits: [
	              {
	                type: "text",
	                name: "CustomUrl",
	                label: "Custom URL",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "BaseUrl",
	                label: "Base URL",
	                options: [
	                  { id: "baseUrl1", name: "Base URL #1" },
	                  { id: "baseUrl2", name: "Base URL #2" },
	                  { id: "baseUrl3", name: "Base URL #3" },
	                  { id: "baseUrl4", name: "Base URL #4" },
	                  { id: "baseUrl5", name: "Base URL #5" },
	                  { id: "null", name: "No Base URL" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIPath",
	                label: "API Path",
	                placeholder: "Don't start with '/'",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "APIMethod",
	                label: "API Method",
	                options: [
	                  { id: "GET", name: "GET" },
	                  { id: "POST", name: "POST" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Username",
	                label: "Username",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Password",
	                label: "Password",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "API_Key",
	                label: "API Key",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "More_Headers",
	                label: "More Headers",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "APIBody",
	                label: "API Body",
	                changeProp: true,
	              },
	              {
	                type: "select",
	                name: "Animation",
	                label: "Pre-defined Graph Animations",
	                options: [
	                  { id: "delay", name: "Delay" },
	                  { id: "hideAndShow", name: "Hide And Show" },
	                ],
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Abscissa",
	                label: "Abscissa",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Ordinate",
	                label: "Ordinates",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Bar_Colors",
	                label: "Datapoint Colors",
	                changeProp: true,
	              },
	              {
	                type: "range",
	                min: "0",
	                max: "20",
	                name: "Border_Width",
	                label: "Border Width [0px to 20px]",
	                changeProp: true,
	              },
	              {
	                type: "text",
	                name: "Border_Color",
	                label: "Border Color",
	                changeProp: true,
	              },
		            {
		                type: "text",
		                name: "UpdateFrequencyDropdownID",
		                label: "UpdateFrequency Dropdown ID",
		                placeholder: "For example: pie-chart-uf-opts",
		                changeProp: true,
		            },
	              // {
	              //     type: 'checkbox',
	              //     name: 'Fill',
	              //     label: 'Fill Area',
	              //     changeProp: true,
	              // },
				  {
	                  type: 'checkbox',
	                  name: 'DisableLegend',
	                  label: 'Disable Legend',
	                  changeProp: true,
	              },
	            ],

	            changeProp: true,

	            "script-props": [
	              "CustomUrl",
	              "BaseUrl",
	              "APIPath",
	              "APIMethod",
	              "BaseVars",
	              "API_HOST",
	              "projectId",
	              "Username",
	              "Password",
	              "API_Key",
	              "More_Headers",	             
	              "APIBody",
	              "Animation",
	              "Abscissa",
	              "Ordinate",
	              "Bar_Colors",
	              "Border_Width",
	              "Border_Color",
	              "UpdateFrequencyDropdownID",
				  "options",
				  "DisableLegend",
	            ],
	          },
	        },

	        isComponent: (el) => {
	          if (
	            el.getAttribute &&
	            el.getAttribute("data-gjs-type") == "pie-chart"
	          ) {
	            return "pie-chart";
	          }
	        },
	        view: defaultView.extend({
	          init({ model }) {},
	        }),
	    });
    }
};

export default TwoDCharts;